import styled from 'styled-components';

export const FillCircle = styled.div<{ fill: number }>`
  width: 1rem;
  height: 1rem;
  border-radius: 0.5rem;
  background: conic-gradient(
    ${({ theme, fill }) => {
        if (fill > 0.7) {
          return theme.red;
        }
        if (fill > 0.4) {
          return theme.orange;
        }
        return theme.green;
      }}
      0deg ${({ fill }) => fill * 360}deg,
    ${({ theme }) => theme.gray1} ${({ fill }) => fill * 360}deg 360deg
  );
  position: relative;

  &:after {
    content: '';
    width: 0.625rem;
    height: 0.625rem;
    border-radius: 0.5rem;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: ${({ theme }) => theme.bg2};
  }
`;

export const FillBar = styled.div<{ fill: number }>`
  position: relative;
  width: 0.225rem;
  height: 1rem;
  margin-left: 0.8rem;
  border-radius: 1px;
  background: ${({ theme, fill }) => (fill > 0.7 ? theme.red : theme.gray1)};

  &:before {
    content: '';
    display: block;
    position: absolute;
    width: 0.225rem;
    height: 0.8rem;
    right: 0;
    bottom: 0;
    transform: translateX(-0.35rem);
    margin-left: 0.625rem;
    border-radius: 1px;
    background: ${({ theme, fill }) => {
      if (fill > 0.7) {
        return theme.red;
      }
      if (fill > 0.4) {
        return theme.orange;
      }
      return theme.gray1;
    }};
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 0.225rem;
    height: 0.6rem;
    right: 0;
    bottom: 0;
    transform: translateX(-0.7rem);
    margin-left: 0.625rem;
    border-radius: 1px;
    background: ${({ theme, fill }) => {
      if (fill > 0.7) {
        return theme.red;
      }
      if (fill > 0.4) {
        return theme.orange;
      }
      if (fill > 0) {
        return theme.green;
      }
      return theme.gray1;
    }};
  }
`;
